var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 16,
    viewBox: "0 0 15.999 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5864",
    "data-name": "Group 5864",
    transform: "translate(-8648 -19328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-start-3131880",
    d: "M78-.016a8,8,0,1,0,8,8,8.008,8.008,0,0,0-8-8Zm0,1a7,7,0,1,1-7,7,6.989,6.989,0,0,1,7-7ZM74.975,3.5a.5.5,0,0,0-.48.5v7.968a.5.5,0,0,0,.724.446l7.968-3.982a.5.5,0,0,0,0-.9L75.218,3.554a.5.5,0,0,0-.243-.052ZM75.5,4.808l6.347,3.175L75.5,11.161Z",
    transform: "translate(8578 19328.016)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.1d715abb3c26525d5d2809bf53fd6ed2.svg";
export { ForwardRef as ReactComponent };